/* eslint-disable comma-dangle */
/* eslint-disable semi */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API_URL } from "../configs/apiConfig";
import axios from "axios";

export const fetchCompetitions = createAsyncThunk(
  "competitions/fetchAll",
  async (_, { rejectWithValue }) => {
    try {
      const adminToken = localStorage.getItem("adminToken");
      if (!adminToken) {
        return rejectWithValue("Authentication token not found.");
      }
      const response = await axios.get(`${API_URL}/admin/competition`, {
        headers: {
          Authorization: `Bearer ${adminToken}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const competitionsSlice = createSlice({
  name: "competitions",
  initialState: {
    items: [],
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCompetitions.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchCompetitions.fulfilled, (state, action) => {
        state.isLoading = false;
        state.items = action.payload;
      })
      .addCase(fetchCompetitions.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export default competitionsSlice.reducer;
